import { createApp } from 'vue'
import __t from "../../../helpers/translate";
import vue_helpers from "../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import tender from "./tender.vue";

window.tenderContrInsidepp = createApp({
    name : "tenderApp",
    id : "tenderApp",
    components : {
        tender : tender,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);
tenderContrInsidepp.mount('#tender_app');